var map = {
	"./box1.png": 45946,
	"./box2.png": 76031,
	"./box3.png": 98827,
	"./box4.png": 13420,
	"./box5.png": 28549,
	"./box6.png": 48938,
	"./box7.png": 10628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10972;